import { SERVICE_INELIGIBLE_REASON } from '@features/applications/applications.constants.ts';
import { isResidential } from '@features/wizard/service.utils.ts';

import { Service } from '@/types/api.ts';
import {
  ServiceIneligibleStatus,
  ServiceStatus
} from '@/types/service.ts';

const SERVICE_STATUS_TO_FAILURE_REASON: Partial<Record<ServiceStatus, ServiceIneligibleStatus>> = {
  [SERVICE_INELIGIBLE_REASON.COMMERCIAL]: SERVICE_INELIGIBLE_REASON.COMMERCIAL,
  [SERVICE_INELIGIBLE_REASON.UNAVAILABLE]: SERVICE_INELIGIBLE_REASON.UNAVAILABLE,
  [SERVICE_INELIGIBLE_REASON.UNAVAILABLE_COT]: SERVICE_INELIGIBLE_REASON.UNAVAILABLE_COT
};

type ServiceEligibilityValidator = (service: Service) => boolean;

const isResidentialValidator: ServiceEligibilityValidator = (service: Service) => {
  if (!service) return false;

  return isResidential(service);
};

const isValidationResultReason = (validationResult: ServiceIneligibleStatus | undefined): validationResult is ServiceIneligibleStatus => {
  return !!validationResult;
};

const getEligibleServiceValidationResult = (service: Service) => {
  const isValid = isResidentialValidator(service);

  if (!isValid) {
    return SERVICE_STATUS_TO_FAILURE_REASON[service.status] ?? SERVICE_INELIGIBLE_REASON.UNAVAILABLE;
  }

  return undefined;
};

export {
  getEligibleServiceValidationResult,
  isValidationResultReason
};
